import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ALERT_TYPE } from 'src/app/constants';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';

@Component({
    selector: 'app-delete-reason',
    templateUrl: './delete-reason.component.html',
    styleUrls: ['./delete-reason.component.scss'],
    standalone: false
})
export class DeleteReasonComponent {
  private activeModal = inject(NgbActiveModal);
  private sharedService = inject(SharedService);
  protected enums = inject(Enums);

  deleteRemark: string;
  disabledSubmit = false;
  @Input() type = "Deletion";

  @Output() passEntry = new EventEmitter<any>();

  submit() {
    if (this.deleteRemark == undefined || this.deleteRemark == "")
      this.sharedService.openAlert("Please key in your reason to proceed with the action!", ALERT_TYPE.DANGER);
    else
      this.passEntry.emit(this.deleteRemark);

    this.activeModal.close();
  }

  reset() {
    this.deleteRemark = "";
    this.activeModal.close();
  }
}
